export enum PolicyType {
    PRIVACY_POLICY = 'PRIVACY_POLICY',
    TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}

export enum PolicyStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export interface Policy {
    id?: number;
    type: PolicyType;
    version: string;
    title?: string | null;
    titleVi?: string | null;
    content?: string | null;
    contentVi?: string | null;
    status?: PolicyStatus;
    effectiveAt?: string | null;
    createdTime?: string;
    modifiedTime?: string;
}

export interface PolicyHeading {
    id: string;
    title: string;
}
